import { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { Skeleton } from 'src/common/Skeleton';

interface TripDetailsDriverNotesProps {
  isTripDataLoading: boolean;
  trip: TripRead | undefined;
}

export function TripDetailsDriverNotes({
  isTripDataLoading,
  trip,
}: TripDetailsDriverNotesProps) {
  if (!trip || !trip.driver_entered_notes) {
    return null;
  }

  return (
    <div>
      <h4 className="py-2 text-sm font-bold">Driver Notes</h4>
      {isTripDataLoading ? (
        <Skeleton />
      ) : (
        <div className="text-sm">{trip.driver_entered_notes}</div>
      )}
    </div>
  );
}
